export default __webpack_public_path__ + "static/Metal_Foundation-913805958325cb137c93441fea24e851.png";